// 引入axios请求 并配置域名
import axios from 'axios'
import {Message} from 'element-ui'
import {requestHeaderHook} from '@/utils/tokenHandler'

// 防止重复重定向的标志
let isRedirecting = false

export const request = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 6000, // 请求超时时间
})

// 请求拦截器
request.interceptors.request.use(async config => {
  // 请求头添加token
  config.headers = await requestHeaderHook(config.headers)
  // console.log('请求拦截器 config:', config)
  return config
})

// 响应拦截器
request.interceptors.response.use((response) => {
  // console.log("response ==>", response)
  if (response.status === 200) {
    let {checkResult} = response.data
    // console.log("checkResult ==>", checkResult)
    if (response.data === '') {
      return response
    }
    if (checkResult?.allowed) {
      return response
    }
    if (!checkResult?.allowed) {
      // console.log('走这里')
      const {resultCode, resultMessage} = checkResult
      let message = `请求失败,${resultMessage}`
      Message({
        message,
        type: 'error',
        duration: 5 * 1000,
      })

      // 处理token失效的情况
      if (['40021', '40022'].includes(resultCode) || ['invaild token', 'token is null'].includes(resultMessage)) {
        // 防止重复重定向
        if (!isRedirecting) {
          isRedirecting = true

          // 清除本地缓存
          localStorage.removeItem('userInfo')
          localStorage.removeItem('token')

          // 记录当前页面地址，以便登录后能回到当前页面
          const currentUrl = encodeURIComponent(window.location.href)
          localStorage.setItem('redirect_after_login', currentUrl)

          // 延迟重定向，避免请求队列中的其他请求也触发重定向
          setTimeout(() => {
            window.location.href = '/'
            isRedirecting = false // 重置标志
          }, 1000)
        }
      }

      return Promise.resolve({checkResult})
    }
  }

  return response // 添加默认返回，处理其他情况
}, (error) => {
  // 处理网络错误
  console.error('请求错误:', error)
  Message({
    message: '网络连接失败，请稍后重试',
    type: 'error',
    duration: 5 * 1000,
  })
  return Promise.reject(error)
})
